import { forwardRef } from 'react';
import { TextInput as MantineTextInput, type TextInputProps } from '@mantine/core';

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({ size = 'xs', ...props }, ref) => {
    return <MantineTextInput size={size} ref={ref} {...props} />;
});
